import { LOGOUT } from "./types"

export const onLogout = () => (dispatch) => {
  localStorage.clear()
  window.location.replace(window.location.origin)

  dispatch({
    type: LOGOUT,
  })
}